import { useTranslation } from 'react-i18next';

type MicrosoftSignInButtonProps = {
  onClick: () => void;
  isLoading?: boolean;
  disabled?: boolean;
};

export const MicrosoftSignInButton = ({
  onClick,
  isLoading = false,
  disabled = false,
}: MicrosoftSignInButtonProps) => {
  const { t } = useTranslation('auth');

  return (
    <button
      onClick={onClick}
      disabled={disabled || isLoading}
      type="button"
      className="w-full flex items-center justify-center gap-3 bg-[#2F2F2F] hover:bg-[#1F1F1F] text-white font-semibold py-3 px-4 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      aria-label="Sign in with Microsoft"
    >
      {isLoading ? (
        <>
          <div className="h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
          <span>{t('login.signingIn')}</span>
        </>
      ) : (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="21"
            viewBox="0 0 21 21"
            aria-hidden="true"
          >
            <rect x="1" y="1" width="9" height="9" fill="#f25022" />
            <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
            <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
            <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
          </svg>
          <span>{t('login.signInButton')}</span>
        </>
      )}
    </button>
  );
};
